/**
 * V1.1 Task 4 — pure presentational sub-component for the recent-runs
 * (history) table on the orphan-audit viewer.
 */

import type { OrphanAuditReport } from "../../../api/admin-storage-orphan-audit";
import { tableStyles as ts } from "../../../components/TableParts";
import { t } from "../../../i18n";
import {
  formatBytes,
  formatIso,
  auditStyles as styles,
} from "./storage-orphan-audit-helpers";

export function HistoryTable({
  entries,
}: {
  entries: OrphanAuditReport["history"];
}): React.JSX.Element {
  if (entries.length === 0) {
    return (
      <section style={styles.card}>
        <h2 style={styles.cardTitle}>{t("storage_orphan_audit.history")}</h2>
        <p style={styles.emptyText}>
          {t("storage_orphan_audit.no_history_data")}
        </p>
      </section>
    );
  }
  return (
    <section style={styles.card}>
      <h2 style={styles.cardTitle}>{t("storage_orphan_audit.history")}</h2>
      <table style={ts.table}>
        <thead>
          <tr>
            <th style={ts.th}>{t("storage_orphan_audit.col_run_at")}</th>
            <th style={ts.th}>{t("storage_orphan_audit.col_count")}</th>
            <th style={ts.th}>{t("storage_orphan_audit.col_bytes")}</th>
            <th style={ts.th}>{t("storage_orphan_audit.col_environment")}</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.run_at} style={ts.row}>
              <td style={ts.td}>{formatIso(e.run_at)}</td>
              <td style={ts.td}>{e.count}</td>
              <td style={ts.td}>{formatBytes(e.total_bytes)}</td>
              <td style={ts.td}>
                {e.is_prod
                  ? t("storage_orphan_audit.env_prod")
                  : t("storage_orphan_audit.env_nonprod")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
